// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"cfee7466","167":"943d17a8","453":"4a6563bf","855":"026a420c","881":"ae7bf69f"}[chunkId] + ".chunk.js";
};